import React, { useState, useEffect } from "react";
import { useNavigate, useOutletContext } from "react-router-dom";
import { useSelector } from "react-redux";
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import { IconButton } from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import ConfirmationModal from "views/components/ConfirmationModal";
import { endpoint } from "assets/api/endpoint";
import { apiHandler } from "assets/api";
import CircularProgresss from "components/CircularProgress/CircularProgresss";
import ColumnGroupingTable from "components/UpdateUi/Table/Table";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import FindStructureData from "helper/FindStructureType";
import ToastModal from "views/components/ToastModal";
import { formatAmount } from "utils/Utils";
import { toCamelCase } from "utils/Utils";
import { parseAndSetFlag } from "utils/Utils";
import { collaterealEvaluationTableColumns } from "assets/properties/properties";
import { formatRoleStringPretty } from "utils/Utils";
const CollateralEvaluationMaster = () => {
  const navigate = useNavigate();
  const [rawData, setRawData] = useState([]);
  const [selectedTableData, setSelectedTableData] = useState([]);
  const [structureTypeData, setStructureTypeData] = useState([]);
  const [branchList, setBranchList] = useState([]);
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastMessageType, setToastMessageType] = useState('');
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [confirmationModalHeader, setConfirmationModalHeader] = useState("");
  const [confirmationModalMsg, setConfirmationModalMsg] = useState("");
  const [deleteId, setDeleteId] = useState("");
  const { authToken } = useSelector((state) => state.login.authData);
  const [callInProgress, setCallInProgress] = useState(false);
    const outletData = useOutletContext();
    const applicantionSubTypeEnabledColateral = parseAndSetFlag(outletData?.applicantionSubTypeEnabledColateral);
  // submit create function
  const handleCreateDueDiligence = () => {
    navigate(`/coreservice/collateral-create`);
  };
  // message popup
  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
    setToast(showToast);
  };
  // get api calling
  useEffect(() => {
    // GetData();
    getBranchList();
    FindStructureData(apiHandler, endpoint, authToken, setStructureTypeData);
  }, []);

  const getBranchList = async () => {
    let branchCodes = structureTypeData.filter((b) => b.branchType === true);
    if (branchCodes.length > 0) {
      branchCodes.forEach(async (branch) => {
        setCallInProgress(true);
        const result = await apiHandler({
          url: endpoint.MASTER_HIERARCHY_FIND_BY_TYPE_CODE + branch?.code,
          authToken: authToken,
        });
        setCallInProgress(false);
        if (result?.data?.error_code) {
          toastUpdate("Error", result?.data?.user_description,true);
        } else {
          setBranchList(result?.data);
          GetData(result?.data);
        }
      });
    }
  };

  useEffect(() => {
    if (structureTypeData.length) {
      getBranchList();
    }
  }, [structureTypeData.length]);
  const GetData = async (data) => {
    setCallInProgress(true);
    const result = await apiHandler({
      url: endpoint.COLLATERAL_EVALUATION_FINDALL,
      authToken: authToken,
    });
    setCallInProgress(false);
    if (result?.data?.error_code) {
      toastUpdate("Error", result?.data?.user_description,true);
    } else {
      setRawData(result?.data);
      result?.data?.sort((a, b) => {
        // First, sort by branchCode
        if (b.branchCode !== a.branchCode) {
          return b.branchCode.localeCompare(a.branchCode);
        }
        // If branchCode is the same, sort by level
        return a.level - b.level;
      });
      parseIndicatorData(result?.data, data);
    }
  };

  // parseindicatordata function
const parseIndicatorData = (data, branchData) => {
  let reportData = [];
  let lastRowOfBranchSubType = {};
  let levelTracker = {};
  const subTypeOrder = {
    null: 0,
    "PRE_PLEDGE": 1,
  };
  const getKey = (role) =>
    `${role.branchCode?.toLowerCase()}_${role.applicationSubType ?? "null"}`;
  const sortedData = [...data].sort((a, b) => {
    const branchCompare = a.branchCode.localeCompare(b.branchCode);
    if (branchCompare !== 0) return branchCompare;

    const subA = a.applicationSubType ?? null;
    const subB = b.applicationSubType ?? null;
    const subCompare =
      (subTypeOrder[subA] ?? 0) - (subTypeOrder[subB] ?? 0);
    if (subCompare !== 0) return subCompare;

    return a.level - b.level;
  });

  sortedData.forEach((role) => {
    lastRowOfBranchSubType[getKey(role)] = role;
  });

  sortedData.forEach((role) => {
    const key = getKey(role);

    if (!levelTracker[key]) {
      levelTracker[key] = 1;
    } else {
      levelTracker[key] += 1;
    }

    const branchName = branchData?.find(
      (item) => item?.code?.toLowerCase() === role?.branchCode?.toLowerCase()
    );

    let row = {
      role: formatRoleStringPretty(role.role),
      branch: branchName?.name,
      designation: role.designation,
      min: formatAmount(role.minAmt),
      max: formatAmount(role.maxAmt),
      level: levelTracker[key],
      applicationSubType: toCamelCase(role.applicationSubType) ?? "Non BT",
      action: getIcons(role.id, "edit"),
      viewCode: role.id,
    };

    if (lastRowOfBranchSubType[key] === role) {
      row.action = getIcons(role.id);
    }

    reportData.push(row);
  });

  setSelectedTableData(reportData);
};
  const filteredTableData = !applicantionSubTypeEnabledColateral
  ? collaterealEvaluationTableColumns?.filter((item) => item.id !== "applicationSubType")
  : collaterealEvaluationTableColumns ?? [];
  // icons function
  const getIcons = (id,edit) => {
    return (
      <>
        <IconButton aria-label="Edit id" onClick={(e) => {
            e.stopPropagation();
            onClickUpdateData(id)
          }}>
          <EditIcon />
        </IconButton>
        {!edit &&
        <IconButton
          aria-label="Delete id"
          onClick={(e) => {
            e.stopPropagation();
            onClickDeleteData(id)}}
        >
          <DeleteIcon />
        </IconButton>
      }
      </>
    );
  };
  // update function
  const onClickUpdateData = (id) => {
    navigate(`/coreservice/Collateral-create/` + id);
  };
  // delete function
  const onClickDeleteData = (id) => {
    setConfirmationModalHeader("Collateral Valuation");
    setConfirmationModalMsg("Are you sure you want to delete this entry");
    setDeleteId(id);
    setConfirmationModal(true);
  };
  const handleNegativeResponse = () => {
    setConfirmationModal(false);
    setConfirmationModalHeader("");
    setConfirmationModalMsg("");
    setDeleteId("");
  };
  const handlePositiveResponse = async () => {
    const roleid = deleteId;
    handleNegativeResponse();
    setCallInProgress(true);
    // Call API to delete Role
    const res = await apiHandler({
      url: endpoint.COLLATERAL_EVALUATION_DELETE + roleid,
      method: "DELETE",
      authToken: authToken,
    });
    setCallInProgress(false);
    if (res?.data?.error_code) {
      toastUpdate("Error", res?.data?.user_description,true);
    } else {
      toastUpdate("Success", "Delete is successful", true);
      GetData(branchList);
    }
  };

  // serach function
  const onSearchChange = (event) => {
    const filteredData = rawData.filter((row) => {
      const val = event.target.value;
      return (
        row.role?.toLowerCase()?.includes(val?.toLowerCase()),
        row.hierarchyCode?.toLowerCase()?.includes(val?.toLowerCase()),
        row.branchCode?.toLowerCase()?.includes(val?.toLowerCase())
      );
    });
    parseIndicatorData(filteredData);
  };

  // view function
  const onClickViewData = (code, type)=>{
    navigate(`/coreservice/Collateral-createView/` + code );
  }
  return (
    <GridContainer>
      <GridItem xs={12} sm={12} md={12}>
        <SubHeader
          label="Collateral Valuation"
          onSearchChange={onSearchChange}
          searchLabel="Search For Collateral Valuation"
          search
          button1="Create"
          button1click={handleCreateDueDiligence}
        />
      </GridItem>
      <GridItem xs={12} sm={12} md={12}>
        <ColumnGroupingTable columns={filteredTableData} rows={selectedTableData} onClickViewData={onClickViewData} clickable/>
      </GridItem>
      {toast && (
          <ToastModal
            toastMessage={toastMessage}
            toastMessageType={toastMessageType}
            toastUpdate={toastUpdate}
          />
        )}
      {callInProgress && <CircularProgresss callInProgress={callInProgress} />}
      <ConfirmationModal
        confirmationModal={confirmationModal}
        confirmationModalHeader={confirmationModalHeader}
        confirmationModalMsg={confirmationModalMsg}
        handleNegativeButton={handleNegativeResponse}
        handlePositiveButton={handlePositiveResponse}
      />
    </GridContainer>
  );
};

export default CollateralEvaluationMaster;
